import { useBankingAccounts } from "Api/Queries/Accounts/useBankingAccounts";
import { useUserMarketCurrency } from "Hooks/useUserMarketCurrency";

type ReturnType = {
  hasPrimaryAccount: boolean | undefined;
  isLoading: boolean;
  isError: boolean;
};

/**
 * Primary is per currency; what the app-wide consumers (missing-primary popup, dashboard
 * CTAs) care about is a primary on the user's MARKET rail — a foreign-currency primary
 * does not make the user receivable in their market. Region-less context -> undefined
 * (callers already treat undefined as unknown/loading).
 */
export const useHasPrimaryAccount = (): ReturnType => {
  const marketCurrency = useUserMarketCurrency();
  const { data, isLoading, isError } = useBankingAccounts();

  const hasPrimaryAccount =
    marketCurrency === undefined
      ? undefined
      : data?.items.some(
          ({ isPrimary, currency }) => isPrimary && currency === marketCurrency,
        );

  return {
    hasPrimaryAccount,
    isLoading,
    isError,
  };
};
